import React from 'react';
// @ts-ignore
import parse from 'html-react-parser';
import { FaqType } from './types/FaqsTypes';
import ModalConstructor from '../../../../shared/components/ModalConstructor';
import { createSanitizedInnerHTML } from '../../../../shared/utils/htmlSanitizer';

interface FaqsAnswerModalProps {
    isOpen: boolean;
    setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
    faq: FaqType|null;
    setFaq: React.Dispatch<React.SetStateAction<FaqType|null>>;
}
const FaqsAnswerModal: React.FC<FaqsAnswerModalProps> = (props) => {
    const { faq, isOpen, setIsOpen, setFaq } = props;

    if(faq == null)
        return null;


    // @ts-ignore
    return (<ModalConstructor
            closeable
            closeAction
            size="xl"
            title={faq?.titulo}
            open={isOpen}
            setOpen={setIsOpen}
        >
          <div>
            {parse(createSanitizedInnerHTML(faq.conteudo).__html)}
          </div>
        </ModalConstructor>
    )
}
export default FaqsAnswerModal;
